import { getTranslation } from '@/composables/data-display-utils';
import type { Locales, ThemeManifestEntry } from '@/services/types/api.types';

/** A theme as a selector option: its label in the given languages, or its key when it has none there. */
export const themeOption = (theme: ThemeManifestEntry, languageEnabled: Locales[] | undefined) => ({
  label: getTranslation(theme, 'label', languageEnabled) || theme.key,
  value: theme.key,
});

/** The themes every community may pick: a custom one, made for one community, is set by Cocoriko in the database. */
export const themesOfferedToAll = (themes: ThemeManifestEntry[]) =>
  themes.filter((theme) => theme.offeredToAll === true);
